var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "AddToBasket-wrapper h-100 empty wrapper wrap-right",
      attrs: { id: "add-item-to-basket-overlay", "aria-hidden": "true" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal position-relative h-100 p-0",
          attrs: { id: "modalWrapper" }
        },
        [
          _vm.basketItem
            ? _c(
                "div",
                {
                  staticClass:
                    "AddToBasket-preview d-flex flex-column flex-nowrap bg-white shadow w-100 modalBody"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "external-menu-header bg-black d-flex modalHeader"
                    },
                    [
                      _c("div", { staticClass: "d-flex title-section" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "22.5",
                              height: "20",
                              viewBox: "0 0 22.5 20"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "shopping-cart-solid",
                                d:
                                  "M20.63,11.77l1.847-8.125A.938.938,0,0,0,21.562,2.5H6.219L5.861.75A.937.937,0,0,0,4.943,0H.938A.937.937,0,0,0,0,.938v.625A.937.937,0,0,0,.938,2.5h2.73L6.411,15.915a2.188,2.188,0,1,0,2.619.335H17.22a2.187,2.187,0,1,0,2.484-.406l.216-.948a.938.938,0,0,0-.914-1.145H8.52L8.265,12.5H19.716A.937.937,0,0,0,20.63,11.77Z",
                                fill: "#fff"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "f-light",
                            staticStyle: { "margin-left": "20px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "ETCeresCoconut::Template.singleItemAddToBasketHeadline"
                                )
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close-modal-button",
                          attrs: {
                            id: "AddToBasketClose",
                            type: "button",
                            "data-dismiss": "modal"
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "20",
                                viewBox: "0 0 21.414 21.414"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Gruppe_1210",
                                    "data-name": "Gruppe 1210",
                                    transform: "translate(-209.793 -12.793)"
                                  }
                                },
                                [
                                  _c("line", {
                                    attrs: {
                                      id: "Linie_51",
                                      "data-name": "Linie 51",
                                      x2: "20",
                                      y2: "20",
                                      transform: "translate(210.5 13.5)",
                                      fill: "none",
                                      stroke: "#fff",
                                      "stroke-width": "2"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      id: "Linie_52",
                                      "data-name": "Linie 52",
                                      y1: "20",
                                      x2: "20",
                                      transform: "translate(210.5 13.5)",
                                      fill: "none",
                                      stroke: "#fff",
                                      "stroke-width": "2"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "AddToBasket-addedItem d-flex p-0 bg-lightgrey"
                    },
                    [
                      _c("div", { staticClass: "row is-table-row" }, [
                        _c(
                          "div",
                          { staticClass: "add-item-to-basket-itemImage" },
                          [
                            _c("lazy-img", {
                              staticClass: "img-fluid mx-auto",
                              attrs: {
                                "image-url":
                                  _vm.variation.images.all[0].urlPreview,
                                alt: _vm.imageAlternativeText || _vm.itemName,
                                title: _vm.itemName
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "add-item-to-basket-itemData" },
                          [
                            _c(
                              "div",
                              { staticClass: "m-0 p-0" },
                              [
                                _c("div", { staticClass: "AddItemName" }, [
                                  _vm._v(_vm._s(_vm.itemName))
                                ]),
                                _vm._v(" "),
                                _vm.countAdditionalBasketItems > 0
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.basketItemOverlayAdditionalCount",
                                            {
                                              count:
                                                _vm.countAdditionalBasketItems
                                            }
                                          )
                                        )
                                      ),
                                      _c("br")
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.basketItem.quantity) +
                                    " x " +
                                    _vm._s(_vm._f("currency")(_vm.price))
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _vm._l(_vm.variation.attributes, function(
                                  attribute
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: attribute.id,
                                      staticClass: "m-0 p-0"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            attribute.attribute.names.name
                                          ) +
                                          ": "
                                      ),
                                      _c("span", { staticClass: "f-medium" }, [
                                        _vm._v(
                                          _vm._s(attribute.value.names.name)
                                        )
                                      ]),
                                      _c("br")
                                    ]
                                  )
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.$store.getters.currentItemVariation.variation
                              .id == _vm.basketItem.variationId
                              ? [
                                  _vm.needSpecialAccessory
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "add-item-info bg-etcRed"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "ETCeresCoconut::Template.singleItemAddToBasketInfoLeuchtmittelExklusive"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "AddToBasket-content" }, [
                    _c(
                      "div",
                      { staticClass: "AddToBasket-main" },
                      [
                        _vm.needSpecialAccessory
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "AddToBasket-InfoSection f-medium"
                                },
                                [
                                  _vm.crossProducts.length > 0
                                    ? [
                                        _vm.$store.getters.currentItemVariation
                                          .variation.id ==
                                        _vm.basketItem.variationId
                                          ? [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "ETCeresCoconut::Template.singleItemAddToBasketInfoLeuchtmittelCrossselling"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "d-flex",
                                                  attrs: {
                                                    id:
                                                      "AddToBasketLinkToCategory",
                                                    href: _vm.$translate(
                                                      "ETCeresCoconut::Template.singleItemAddToBasketLeuchtmittelCrosssellingCategoryUrl"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "ETCeresCoconut::Template.singleItemAddToBasketInfoLeuchtmittelCrosssellingCategory"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticStyle: {
                                                        "margin-left":
                                                          "0.89289rem"
                                                      },
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "6.069",
                                                        height: "10",
                                                        viewBox: "0 0 6.069 10"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "chevron-right-solid",
                                                          d:
                                                            "M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z",
                                                          transform:
                                                            "translate(-27.495 -37.657)",
                                                          fill: "#464646"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "AddToBasket-cross-selling" },
                                [
                                  _vm.$store.getters.currentItemVariation
                                    .variation.id == _vm.basketItem.variationId
                                    ? [
                                        _vm.crossProducts.length > 0
                                          ? _vm._l(_vm.crossProducts, function(
                                              item
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: item.id,
                                                  staticClass:
                                                    "crossselling-card d-flex"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "crossselling-thumb p-0 d-flex"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass: "d-flex",
                                                          staticStyle: {
                                                            position: "relative"
                                                          },
                                                          attrs: {
                                                            href: _vm._f(
                                                              "itemURL"
                                                            )(
                                                              item.data,
                                                              _vm.urlWithVariationId
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm.eekImageUrl(item)
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "eek-img-section",
                                                                  staticStyle: {
                                                                    position:
                                                                      "absolute",
                                                                    right: "0",
                                                                    bottom: "0"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "lazy-img",
                                                                    {
                                                                      attrs: {
                                                                        "image-url": _vm.eekImageUrl(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("lazy-img", {
                                                            attrs: {
                                                              "picture-class":
                                                                "img-fluid",
                                                              "image-url":
                                                                item.data.images
                                                                  .all[0]
                                                                  .urlSecondPreview
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "crossselling-info d-flex p-0"
                                                    },
                                                    [
                                                      item.data.texts
                                                        .technicalData
                                                        ? _c("div", {
                                                            staticClass:
                                                              "technical-data p-0",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.data.texts
                                                                  .technicalData
                                                              )
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "bg-lightgrey d-flex price-section"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "p-0 prices"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "m-0 p-0 f-bold",
                                                                      staticStyle: {
                                                                        "line-height":
                                                                          "1.5rem"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .data
                                                                            .prices
                                                                            .default
                                                                            .unitPrice
                                                                            .formatted
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "m-0 p-0 f-light",
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "0.85717rem",
                                                                        "line-height":
                                                                          "1.2857rem"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$translate(
                                                                            "ETCeresCoconut::Template.singleItemAddToBasketLeuchtmittelCrosssellingTaxInfo"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "p-0 m-0"
                                                            },
                                                            [
                                                              _vm.needSpecialAccessory
                                                                ? [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex",
                                                                        attrs: {
                                                                          id:
                                                                            "AddToBasketBtn"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "add-to-basket",
                                                                          {
                                                                            attrs: {
                                                                              "data-testing":
                                                                                "item-add-to-basket",
                                                                              "variation-id":
                                                                                item.id,
                                                                              "is-salable": true,
                                                                              "interval-quantity":
                                                                                _vm.neededQuantityAccessory ||
                                                                                1,
                                                                              "minimum-quantity":
                                                                                _vm
                                                                                  .basketItem
                                                                                  .quantity *
                                                                                  Number(
                                                                                    _vm.neededQuantityAccessory
                                                                                  ) ||
                                                                                1,
                                                                              "use-large-scale": false,
                                                                              "show-quantity": true
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            staticStyle: {
                                                                              "margin-left":
                                                                                "6px"
                                                                            },
                                                                            attrs: {
                                                                              xmlns:
                                                                                "http://www.w3.org/2000/svg",
                                                                              width:
                                                                                "6.069",
                                                                              height:
                                                                                "10",
                                                                              viewBox:
                                                                                "0 0 6.069 10"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs: {
                                                                                  id:
                                                                                    "chevron-right-solid",
                                                                                  d:
                                                                                    "M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z",
                                                                                  transform:
                                                                                    "translate(-27.495 -37.657)",
                                                                                  fill:
                                                                                    "#464646"
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            })
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "AddToBasket-footer d-flex bg-lightgrey" },
                      [
                        _c(
                          "div",
                          { staticClass: "AddToBasket-Buttons d-flex" },
                          [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "waiting-animation-infinite",
                                    rawName: "v-waiting-animation-infinite"
                                  }
                                ],
                                staticClass:
                                  "btn btn-secondary position-relative",
                                attrs: {
                                  href: _vm.urls.basket,
                                  rel: "nofollow"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemBasket"
                                      )
                                    ) +
                                    "\n              "
                                ),
                                _c(
                                  "svg",
                                  {
                                    staticClass: "position-absolute",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "16.875",
                                      height: "15",
                                      viewBox: "0 0 16.875 15"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        id: "shopping-cart-solid",
                                        d:
                                          "M15.472,8.828l1.385-6.094a.7.7,0,0,0-.686-.859H4.664L4.4.562A.7.7,0,0,0,3.707,0H.7A.7.7,0,0,0,0,.7v.469a.7.7,0,0,0,.7.7H2.75L4.809,11.937a1.641,1.641,0,1,0,1.964.251h6.142a1.64,1.64,0,1,0,1.863-.3l.162-.711a.7.7,0,0,0-.686-.859H6.39L6.2,9.375h8.588A.7.7,0,0,0,15.472,8.828Z",
                                        fill: "#fff"
                                      }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "waiting-animation-infinite",
                                    rawName: "v-waiting-animation-infinite"
                                  }
                                ],
                                staticClass: "btn btn-primary",
                                attrs: {
                                  href: _vm.urls.checkout,
                                  rel: "nofollow"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemCheckout"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "AddToBasket-overlay overlay",
        attrs: { id: "AddToBasketOverlay" },
        on: { click: _vm.handleOverlayClick }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }